
 <template>
    <a-modal
    title="明细"
    :width="1200"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    footer=""
    :maskClosable="false"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="付款方式">
                <a-select v-model="queryParam.operType"  >
                  <a-select-option  v-for="type in resTypes" :key="type.code">{{type.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单号">
                <a-input  v-model="queryParam.orderNo"  />
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="操作人">
                <a-input  v-model="queryParam.createBy"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="操作时间">
                <a-range-picker
                  v-decorator="['finalRechargeTime']"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChange"
                  @ok="onOk"
                  style="width:200px"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" :style="{ textAlign: 'right' }">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="restdata()">清空</a-button>
            </a-col>
          </a-row>
          <a-divider/>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        :columns="columns"
        :data="loadData"
        style="margin-top: 24px"
        bordered
      >
      <span slot="action" slot-scope="text, record">
        <span v-if="text">{{text}}</span>
        <span v-else >财务修改余额</span>
      </span>
      </s-table>
    </a-modal>
  </template>

  <script>
    import moment from 'moment';
    import { STable } from '@/components'
    import { getDictMap } from '../../../utils/dict'
    import { detailedList } from '@/api/enterprise/enterpriseAccount'
  export default {
    name: "Accountdetailed",
    components:{
      STable,
    },
    data(){
      return{enterpriseId:'',
        visible:false,
        confirmLoading:false,
        queryParam:{},
        form:this.$form.createForm(this),
        resTypes:[],
        loadData: parameter => {
          // this.queryParam.enterpriseId=this.enterpriseId
          return detailedList(Object.assign(parameter, this.queryParam))
        },
        columns: [
          {
            title: '序号',
            dataIndex: 'num',
            align: 'center'
          },
          {
            title: '付款方式',
            dataIndex: 'operType',
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
          {
            title: '订单号',
            dataIndex: 'orderNo',
            align: 'center'
          },
          {
            title: '操作金额',
            dataIndex: 'changeAmount',
            align: 'center'
          },
          {
            title: '操作人',
            dataIndex: 'createBy',
            align: 'center'
          },
          {
            title: '操作时间',
            dataIndex: 'createTime',
            align: 'center'
          },
        ],
      }
    },
  methods:{
    moment,
    restdata(){
      this.form.resetFields()
      this.queryParam.operType=''
        this.queryParam.orderNo=''
        this.queryParam.createBy=''
        this.queryParam.createTime=''


    },
    //最后一次充值日期
    onChange(date, dateString){
      this.queryParam.StartTime=dateString[0]
      this.queryParam.EndTime=dateString[1]
    },
    //退款
    refund(value){
      console.log(value)
      this.$refs.model.add(value)
    },
    //明细
    detailed(value){
      console.log(value)
      this.$refs.model2.add(value)
    },
    handleSubmit(){

    },
    add(value){
      this.restdata()
      this.queryParam.enterpriseId=value.enterpriseId
      // this.enterpriseId=value.enterpriseId
        this.visible=true
      //this.$refs.table.refresh(true)
      },
    },
    async created(){
      // 付款方式
      this.installTypeArr = await getDictMap('Operation_type')
      console.log(this.installTypeArr)
      this.installTypeArr.forEach((value, key) => {
        this.resTypes.push({ code: key, name: value })
      })
    }
  }
  </script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>